import { render } from "./TotalCounts30DaysRanking.vue?vue&type=template&id=62b88776"
import script from "./TotalCounts30DaysRanking.vue?vue&type=script&lang=js"
export * from "./TotalCounts30DaysRanking.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lasse/Documents/DOFprojects/spontanpunkt-PWA/pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__